import { render } from "./ClubNewsCard.vue?vue&type=template&id=416ced71&scoped=true"
import script from "./ClubNewsCard.vue?vue&type=script&lang=js"
export * from "./ClubNewsCard.vue?vue&type=script&lang=js"

import "./ClubNewsCard.vue?vue&type=style&index=0&id=416ced71&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416ced71"]])

export default __exports__